<div class="cart-page">
  <div id="head"></div>

  <!-- The cart as separate boxes like the home's (owner 2026-10-12): the rows in one with the title and the count
       over them, the checkout in its own box beside it, the suggestions and the guides each in their own under them -->
  <div class="cart-layout">
  <section class="cart-box cart-box-main">
    <header class="cart-head">
      <span class="cart-eyebrow"><app-icon name="cart-shopping" aria-hidden="true"></app-icon>Store</span>
      <div class="cart-title-row">
        <h1 class="cart-title">Your Cart</h1>
        <span class="cart-count" aria-live="polite">
          <span class="cart-count-number" *ngIf="!loading">{{ itemCount }}</span>
          <span class="cart-count-number skeleton-bar skeleton-shimmer" *ngIf="loading" aria-hidden="true"></span>
          <span class="cart-count-label">{{ itemCount === 1 ? 'item' : 'items' }}</span>
        </span>
      </div>
      <p class="cart-lead">Pay once, download right away and keep the latest version for good</p>
    </header>

    <div class="cart-main">
      <!-- Loading: three item silhouettes (the room the cart always has), shimmering, until the store has answered -->
      <div class="cart-body cart-loading" *ngIf="loading" aria-busy="true" aria-label="Loading your cart">
        <div class="cart-rows">
          <!-- the loaded row's silhouette: badge · category / name / colour dots | licence / version / platform |
               price · stepper, the tag pills under it (kept in step with app-store-item-card, 2026-09-21) -->
          <div class="skeleton-row" *ngFor="let row of SKELETON_ROWS" aria-hidden="true">
            <div class="skeleton-main">
              <div class="skeleton-identity">
                <span class="skeleton-logo skeleton-shimmer"></span>
                <span class="skeleton-text">
                  <span class="skeleton-bar skeleton-shimmer" style="width: 96px; height: 9px;"></span>
                  <span class="skeleton-bar skeleton-shimmer" style="width: 180px; height: 18px;"></span>
                  <span class="skeleton-colors">
                    <span class="skeleton-color skeleton-shimmer"></span>
                    <span class="skeleton-color skeleton-shimmer"></span>
                    <span class="skeleton-color skeleton-shimmer"></span>
                    <span class="skeleton-color skeleton-shimmer"></span>
                    <span class="skeleton-color skeleton-shimmer"></span>
                  </span>
                </span>
              </div>
              <div class="skeleton-meta">
                <span class="skeleton-bar skeleton-shimmer" style="width: 104px; height: 12px;"></span>
                <span class="skeleton-bar skeleton-shimmer" style="width: 72px; height: 9px;"></span>
                <span class="skeleton-meta-platform">
                  <span class="skeleton-platform-logo skeleton-shimmer"></span>
                  <span class="skeleton-bar skeleton-shimmer" style="width: 84px; height: 10px;"></span>
                </span>
              </div>
              <div class="skeleton-actions">
                <span class="skeleton-bar skeleton-shimmer" style="width: 52px; height: 18px;"></span>
                <span class="skeleton-pill skeleton-shimmer"></span>
              </div>
            </div>
            <div class="skeleton-footer">
              <span class="skeleton-tag skeleton-shimmer" style="width: 58px;"></span>
              <span class="skeleton-tag skeleton-shimmer" style="width: 82px;"></span>
              <span class="skeleton-tag skeleton-shimmer" style="width: 70px;"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- A free order was just made (owner, 2026-09-21): the downloads mail is the only way to the order
           page, so this panel says where it went, with a Resend for a lost mail -->
      <div class="cart-sent" *ngIf="!loading && sent" role="status" aria-live="polite">
        <div class="empty-illustration" aria-hidden="true">
          <span class="empty-orb">
            <app-icon name="envelope" class="empty-icon"></app-icon>
          </span>
        </div>
        <h2 class="empty-title">Check your inbox</h2>
        <p class="empty-text">Your download link for order <strong>{{ sent.orderNumber }}</strong> is on its way to <strong class="sent-email">{{ sent.email }}</strong>. Open the link in that mail to get your free themes.</p>
        <p class="sent-hint">Not there in a minute? Look in the spam folder, or send it again.</p>
        <div class="sent-actions">
          <button type="button" class="codigrate-button empty-action sent-resend" (click)="resend()" [disabled]="resending || resent">
            <p>{{ resent ? 'Sent again' : ( resending ? 'Sending…' : 'Resend the mail' ) }}</p>
            <app-icon name="rotate" class="sent-resend-icon" aria-hidden="true"></app-icon>
          </button>
          <a class="codigrate-button empty-action" [routerLink]="URLS.themes"><p>Browse themes</p></a>
        </div>
      </div>

      <div class="cart-body" *ngIf="!loading && !sent && lines.length > 0">
      <div class="cart-rows">
        <app-store-item-card *ngFor="let line of lines; trackBy: trackBySku"
                             [attr.data-sku]="line.sku"
                             [class.leaving]="leavingSkus.has(line.sku)"
                             [product]="line.product"
                             [category]="line.category"
                             [productName]="line.productName"
                             [platformName]="line.platformName"
                             [platformLogo]="line.platformLogo"
                             [palette]="line.palette"
                             [app]="line.app" [appUrl]="line.appUrl"
                             [muted]="catalogOk && !line.available">

          <!-- price · quantity -->
          <div cardActions class="line-actions">
            <div class="line-price">
              <span class="line-price-total" *ngIf="line.linePriceLabel">{{ line.linePriceLabel }}</span>
              <span class="line-price-total muted" *ngIf="!line.linePriceLabel">{{ catalogLoaded ? '' : '…' }}</span>
              <!-- hangs under the total (out of the flow) so the total never moves -->
              <span class="line-price-unit" *ngIf="line.quantity > 1 && line.unitPriceLabel">{{ line.quantity }} × {{ line.unitPriceLabel }}</span>
            </div>
            <!-- one cell as wide as the stepper in every row, so the price, the middle column and the trash
                 line up between paid and free rows (owner, 2026-09-21) -->
            <div class="quantity-cell">
            <!-- the same stepper on every row; a free line is one copy (2026-09-21), so its + stays disabled -->
            <div class="quantity" role="group" [attr.aria-label]="'Quantity of ' + line.productName">
              <button type="button" class="quantity-button" (click)="changeQuantity(line, -1)" [attr.aria-label]="line.quantity === 1 ? 'Remove' : 'One less'">
                <app-icon [name]="line.quantity === 1 ? 'trash' : 'minus'" aria-hidden="true"></app-icon>
              </button>
              <span class="quantity-value" aria-live="polite">{{ line.quantity }}</span>
              <button type="button" class="quantity-button" (click)="changeQuantity(line, 1)" [disabled]="line.free || line.quantity >= MAX_QUANTITY"
                      [attr.aria-label]="line.free ? 'One copy per free theme' : 'One more'" [attr.title]="line.free ? 'A free theme is one copy' : null">
                <app-icon name="plus" aria-hidden="true"></app-icon>
              </button>
            </div>
            </div>
          </div>

          <!-- the middle column (owner, 2026-09-20): "Lifetime access" in the theme's colour, the version under it -->
          <div cardMeta class="line-meta">
            <p class="line-licence">Lifetime access<span class="line-version" *ngIf="line.version">ver. {{ line.version }}</span></p>
          </div>

          <!-- under the row (after the card's own tag pills): the availability; getting started sits under the panel -->
          <div cardFooter class="line-footer" *ngIf="catalogOk && (!line.available || !line.purchasable)">
            <p class="line-warning" *ngIf="catalogOk && !line.available">
              This item is no longer available. Remove it to continue.
            </p>
            <p class="line-warning" *ngIf="catalogOk && line.available && !line.purchasable">
              This item can't be purchased right now. Please check back soon.
            </p>
          </div>
        </app-store-item-card>
      </div>

      <!-- Room for more: fewer than three different items, so the way back to the gallery, centred in the room left -->
      <div class="cart-more" *ngIf="lines.length < 3">
        <p class="cart-more-text">{{ mode === 'free' ? 'Room for more? Add another theme and get everything in one order.' : 'Room for more? Pick another product, pay for everything at once, download right away.' }}</p>
        <a class="codigrate-button cart-more-button" [routerLink]="URLS.themes"><p>Browse themes</p></a>
      </div>
      </div>

      <!-- Empty: the same cart, nothing in it yet -->
      <ng-container *ngIf="!loading && !sent && lines.length === 0">
        <div class="cart-empty">
          <div class="empty-illustration" aria-hidden="true">
            <span class="empty-orb">
              <app-icon name="cart-shopping" class="empty-icon"></app-icon>
            </span>
          </div>
          <h2 class="empty-title">Your cart is empty</h2>
          <p class="empty-text">Pick a theme and download it right away. No account needed!</p>
          <a class="codigrate-button empty-action" [routerLink]="URLS.themes"><p>Browse themes</p></a>
        </div>
      </ng-container>
    </div>
  </section>

    <!-- Checkout, at the cart's side in a box of its own: the summary, the total, the button, and Stripe -->
    <aside class="cart-box checkout-card" aria-label="Checkout">
      <span class="checkout-eyebrow">Order summary</span>

      <div class="checkout-loading" *ngIf="loading" aria-hidden="true">
        <span class="skeleton-bar skeleton-shimmer" style="width: 72%; height: 12px;"></span>
        <span class="skeleton-bar skeleton-shimmer" style="width: 40px; height: 12px;"></span>
      </div>
      <p class="checkout-empty" *ngIf="!loading && lines.length === 0">Nothing in your cart yet.</p>
      <ul class="checkout-lines" *ngIf="!loading && lines.length > 0">
        <!-- a line a row (owner 2026-10-12): the name, then how many beside the price at the right, a hairline between -->
        <li *ngFor="let line of lines; trackBy: trackBySku">
          <span class="checkout-line-name">{{ line.title }}</span>
          <span class="checkout-line-amount">
            <span class="checkout-line-meta">× {{ line.quantity }}</span>
            <span class="checkout-line-price">{{ line.linePriceLabel || (catalogLoaded ? '' : '…') }}</span>
          </span>
        </li>
      </ul>

      <div class="checkout-total">
        <span class="checkout-total-label">Total <span class="checkout-total-vat" *ngIf="mode !== 'free'">incl. VAT</span></span>
        <span class="checkout-total-value" *ngIf="!loading">{{ subtotalLabel || '' }}</span>
        <span class="checkout-total-value skeleton-bar skeleton-shimmer" *ngIf="loading" style="width: 72px; height: 26px;" aria-hidden="true"></span>
      </div>

      <!-- a mixed cart (owner, 2026-09-21): the free lines are not on Stripe's list, so say so here, and Stripe's own page names them -->
      <p class="checkout-mixed" *ngIf="!loading && mode === 'mixed'" role="status">
        <app-icon name="gift" aria-hidden="true"></app-icon>
        <span>{{ freeCount === 1 ? '1 free item is' : freeCount + ' free items are' }} included with this order. Stripe shows only the paid items; everything is on your order page after payment.</span>
      </p>

      <!-- a cart of free listings only (owner, 2026-09-21): no payment, the order is made against an address
           (the downloads mail goes there), and the opt-in to news about new themes -->
      <div class="checkout-free" *ngIf="!loading && mode === 'free'">
        <label class="free-email-label" for="free-email">Where should we send your download link?</label>
        <input id="free-email" class="free-email" type="email" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com"
               [(ngModel)]="email" (blur)="emailTouched = true" (keydown.enter)="checkout()" [class.invalid]="emailTouched && !emailValid" [attr.aria-invalid]="emailTouched && !emailValid">
        <p class="free-email-error" *ngIf="emailTouched && !emailValid" role="alert">Please enter a valid e-mail address.</p>
        <div class="free-consent">
          <input type="checkbox" id="free-consent" [(ngModel)]="marketingConsent">
          <label for="free-consent">Send me news about new themes (a few times a year, unsubscribe any time)</label>
        </div>
      </div>

      <button type="button" class="checkout-cta" (click)="checkout()" [disabled]="ctaDisabled">
        <app-icon [name]="mode === 'free' ? 'download' : 'lock'" class="checkout-cta-icon" aria-hidden="true"></app-icon>
        <span>{{ mode === 'free' ? 'Download free' : 'Checkout' }}</span>
        <span class="checkout-cta-arrow" aria-hidden="true">&rarr;</span>
      </button>
      <p class="checkout-error" *ngIf="checkoutError" role="alert">{{ checkoutError }}</p>
      <p class="checkout-notice" *ngIf="catalogFailed && lines.length > 0" role="status">
        <app-icon name="circle-info" aria-hidden="true"></app-icon>
        <span>The store can't be reached right now, so checkout is paused. Your cart stays here and we keep trying.</span>
      </p>

      <!-- a free cart: no payment, so no Stripe (owner, 2026-09-21) -->
      <p class="checkout-note" *ngIf="!loading && mode === 'free'">No payment, no account. Your download link goes to this address, so use one you can open.</p>

      <!-- Secure checkout by Stripe + the ways to pay -->
      <div class="checkout-trust" *ngIf="loading || mode !== 'free'">
        <span class="payment-powered">
          <app-icon name="lock" aria-hidden="true"></app-icon>
          <span>Secure checkout by</span>
          <app-icon name="brand:stripe" class="payment-stripe" aria-label="Stripe"></app-icon>
        </span>
        <span class="payment-methods" aria-label="Payment methods">
          <app-icon name="brand:cc-visa" aria-label="Visa"></app-icon>
          <app-icon name="brand:cc-mastercard" aria-label="Mastercard"></app-icon>
          <app-icon name="brand:cc-amex" aria-label="American Express"></app-icon>
          <app-icon name="brand:apple-pay" aria-label="Apple Pay"></app-icon>
          <app-icon name="brand:google-pay" aria-label="Google Pay"></app-icon>
        </span>
      </div>
      <p class="checkout-note" *ngIf="loading || mode !== 'free'">Prices include VAT; Stripe shows the total in your local currency. Instant download after payment, always the latest version. Digital download, so all sales are final (<a [routerLink]="URLS.storeTerms" class="theme-color-link">Terms of Sale</a>).</p>

    </aside>
  </div>

  <!-- You might also like: three listings that go with the cart, in a box of their own under the cart (the
       visitor is at the checkout, so a nudge to fill the cart; an empty cart gets the picks) -->
  <section class="cart-box cart-box-plain" *ngIf="!loading">
    <app-store-suggestions class="cart-suggestions" [skus]="lineSkus"></app-store-suggestions>
  </section>

  <!-- Getting started: one always-open box per platform in the cart -->
  <section class="cart-box cart-box-plain" *ngIf="!loading && guides.length">
    <app-store-guides class="cart-guides" [guides]="guides"></app-store-guides>
  </section>
</div>
